import { Step as StepInterface } from "@covertree/layouts";

import { StepPath } from "./paths";
import { PolicyDetails } from "./routes/PolicyDetails";
import { MissingPolicyDetails } from "./routes/MissingPolicyDetails";
import { LossLocation } from "./routes/LossLocation";
import { EnterClaimDetails } from "./routes/EnterClaimDetails";
import { UploadClaimDocuments } from "./routes/UploadClaimDocuments";
import { ClaimReporter } from "./routes/ClaimReporter";
import { ClaimSummary } from "./routes/ClaimSummary";
import { ClaimCreationSuccess } from "./routes/ClaimCreationSuccess";

export type Step = StepInterface<StepPath>;

export const steps: Step[] = [
  {
    section: "Policy details",
    title: "Policy details",
    path: StepPath.POLICY_DETAILS,
    Component: PolicyDetails,
  },
  {
    section: "Policy details",
    title: "Missing policy details",
    path: StepPath.MISSING_POLICY_DETAILS,
    Component: MissingPolicyDetails,
  },
  {
    section: "Loss location",
    title: "Loss Location & Details",
    path: StepPath.LOSS_LOCATION_DETAILS,
    Component: LossLocation,
  },
  {
    section: "Claim details",
    title: "Enter claims details",
    path: StepPath.ENTER_CLAIMS_DETAILS,
    Component: EnterClaimDetails,
  },
  {
    section: "Upload photos",
    title: "Upload photos or documents (optional)",
    path: StepPath.UPLOAD_CLAIM_DOCUMENTS,
    Component: UploadClaimDocuments,
  },
  {
    section: "Who's reporting",
    title: "Who's reporting the claim?",
    path: StepPath.WHO_IS_REPORTING_CLAIM,
    Component: ClaimReporter,
  },
  {
    section: "Finalize & submit",
    title: "Review Claim Summary",
    path: StepPath.SUMMARY,
    Component: ClaimSummary,
  },
  {
    section: "",
    title: "Your claim has been successfully submitted",
    path: StepPath.CLAIM_SUBMITTED_SUCCESSFULLY,
    Component: ClaimCreationSuccess,
  },
];
